/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     // console.log('Container ———————— ↓');
  //     // console.log(container);
  //     // console.log('Variant —————————— ↓');
  //     // console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     // console.log('Cart ———————————— ↓');
  //     // console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   // console.log('theme:cart:init');
  //   // console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { 
  //   // const scrolledElement = e.target;
  //   // console.log(e);
  // });
  
  function changeBackgroundOnScroll(event) {
      const scrollDiv = document.querySelectorAll('.app-features-block');
      const featureBlocksContainer = document.querySelector('.app-features-block-container');
      const featureBlocksContainerRect = featureBlocksContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      let divBackground;
      let splitBackgroundValues;
      let firstClass;
      let secondClass;
      let backgroundChangeVerify;

      if(scrollDiv.length - 3 != 0) {
        backgroundChangeVerify =  scrollDiv.length - 1.8;
      }else {
        backgroundChangeVerify = 1;
      }

      if (featureBlocksContainerRect.top > -(windowHeight * backgroundChangeVerify) && 
      featureBlocksContainerRect.top < (windowHeight * backgroundChangeVerify)) {
        scrollDiv.forEach((element, index) => {
          const elementRect = element.getBoundingClientRect();
          if(featureBlocksContainerRect.bottom <= 760) {
            divBackground = element.getAttribute('data-fade-background');
            splitBackgroundValues = divBackground.split(" ");
            firstClass = splitBackgroundValues[0];
            secondClass = splitBackgroundValues[1];
          }else {
            const classList = [
              'palette--light',
              'palette--dark',
              'palette--bright',
              'bg--neutral',
              'bg--accent',
              'bg--invert',
              'bg--invert--accent',
              'bg--bright',
              'bg--bright--accent'
            ];

            for (let i = 0; i < classList.length; i++) {
              featureBlocksContainer.classList.remove(classList[i]);
            }
    
            if (elementRect.top <= windowHeight * 0.7 && elementRect.bottom >= windowHeight * 0.7) {
              divBackground = element.getAttribute('data-fade-background');
              splitBackgroundValues = divBackground.split(" ");
              firstClass = splitBackgroundValues[0];
              secondClass = splitBackgroundValues[1];
            }
          }

          featureBlocksContainer.classList.add(`${firstClass}`);
          featureBlocksContainer.classList.add(`${secondClass}`);

        });
        
      }else {
        if (featureBlocksContainerRect.top >= (windowHeight * (backgroundChangeVerify * 0.8))) {
  
          const classList = [
            'palette--light',
            'palette--dark',
            'palette--bright',
            'bg--neutral',
            'bg--accent',
            'bg--invert',
            'bg--invert--accent',
            'bg--bright',
            'bg--bright--accent'
          ];
  
          for (let i = 0; i < classList.length; i++) {
            featureBlocksContainer.classList.remove(classList[i]);
          }
  
          firstScrollDiv = document.querySelector('.app-features-block');
  
          divBackground = firstScrollDiv.getAttribute('data-fade-background');
          splitBackgroundValues = divBackground.split(" ");
          firstClass = splitBackgroundValues[0];
          secondClass = splitBackgroundValues[1];
  
          featureBlocksContainer.classList.add(`${firstClass}`);
          featureBlocksContainer.classList.add(`${secondClass}`);
  
        }else {
          scrollDiv.forEach((element, index) => {
              const classList = [
                'palette--light',
                'palette--dark',
                'palette--bright',
                'bg--neutral',
                'bg--accent',
                'bg--invert',
                'bg--invert--accent',
                'bg--bright',
                'bg--bright--accent'
              ];
  
              for (let i = 0; i < classList.length; i++) {
                featureBlocksContainer.classList.remove(classList[i]);
              }
    
              divBackground = element.getAttribute('data-fade-background');
              splitBackgroundValues = divBackground.split(" ");
              firstClass = splitBackgroundValues[0];
              secondClass = splitBackgroundValues[1];
  
              featureBlocksContainer.classList.add(`${firstClass}`);
              featureBlocksContainer.classList.add(`${secondClass}`);
  
          });
        } 
      }
    }

  function changePhoneImageOnScroll() {
    const scrollDiv = document.querySelectorAll('.app-features-block');
    const phoneImage = document.querySelectorAll('.phone-image-size');
    const hiddenPhoneImage = document.querySelector('.fixed-phone-image');
    const percentageOfWindowHeight = 0.000030;

    const windowHeight = window.innerHeight;
    let value1;
    let value2;
    let value3;
    let value4;

    let dataImageSrc;
    let currentImageSrc = hiddenPhoneImage.src;

    const screenHeights = [
      { height: 599, value1: 190, value2: 360, value3: 0, value4: 3.1},
      { height: 767, value1: 125, value2: 340, value3: 9, value4: 3 }, // Top Bottom elementTop
      { height: 799, value1: 130, value2: 490, value3: 13, value4: 2.98 },
      { height: 899, value1: 140, value2: 490, value3: 13, value4: 2.99 },
      { height: 979, value1: 150, value2: 580, value3: 13, value4: 2.98 },
      { height: 1079, value1: 150, value2: 580, value3: 13, value4: 2.98 }
    ];

    let screenHeightValues;
    for (const item of screenHeights) {
      if (item.height >= windowHeight) {
        screenHeightValues = item;
        value1 = screenHeightValues.value1;
        if(scrollDiv.length > 3){ 
          if(screenHeightValues.value4 == undefined) {
            value4 = 2.98;
          }else {
            value4 = screenHeightValues.value4;
          }
          value2 = Math.round((screenHeightValues.value2) + (document.querySelector('.app-features-block').offsetHeight) * (scrollDiv.length - value4));
        }else {
          value2 = screenHeightValues.value2;
        }
        value3 = screenHeightValues.value3;
        break;
      }else {
        value1 = windowHeight / 6.5;
        value2 = windowHeight / 1.70;
        value3 = 13;
      }
    }
    
    scrollDiv.forEach((element) => {
      const elementRect = element.getBoundingClientRect();
      const triggerThreshold = (windowHeight * windowHeight) * percentageOfWindowHeight;
  
      if (elementRect.top <= windowHeight * 0.7 && elementRect.bottom >= windowHeight * 0.7 ) {
        dataImageSrc = element.getAttribute('data-phone-image');

        const currentImageSrcNoHttps = currentImageSrc.replace('https:','');
  
        if (currentImageSrcNoHttps !== dataImageSrc) {

          hiddenPhoneImage.style.transitionTimingFunction = "ease-in-out";
          hiddenPhoneImage.style.transition = "0.3s";
          hiddenPhoneImage.style.opacity = "0";
          
          setTimeout(function () {
            hiddenPhoneImage.src = dataImageSrc;
            hiddenPhoneImage.style.opacity = "1";
          }, 350);
  
          currentImageSrc = dataImageSrc;
        }
  
        phoneImage.forEach((element) => {
          element.classList.add('is-hidden');
        });
      }

      const visiblePhone = document.querySelector('.visible-phone-image--top');
      const visiblePhonePosition = visiblePhone.getBoundingClientRect();
      const visiblePhoneBottom = document.querySelector('.visible-phone-image--bottom');
      const visiblePhoneBottomPosition = visiblePhoneBottom.getBoundingClientRect();

      hiddenPhoneImage.classList.remove('is-hidden');
      if (visiblePhonePosition.top > value1 || visiblePhoneBottomPosition.bottom < -value2) {
        phoneImage.forEach((element) => {
          element.classList.remove('is-hidden');
        });
        hiddenPhoneImage.classList.add('is-hidden');
      }
    });

    const visiblePhone = document.querySelector('.visible-phone-image');
    const container = document.querySelector('.app-features-block-container');
    const containerHeight = container.offsetHeight;
    const topPosition = visiblePhone.offsetTop;

    const percentage = ((topPosition / containerHeight) * 100) + value3;
    hiddenPhoneImage.style.top = percentage + '%';
  }

  if(document.getElementsByClassName('app-features-block')[0]) {
    window.addEventListener('scroll', changeBackgroundOnScroll);
    window.addEventListener('load', changeBackgroundOnScroll);
  }

  if(window.innerWidth >= 1024 && document.getElementsByClassName('app-features-block')[0]) {
    window.addEventListener('scroll', changePhoneImageOnScroll);
    window.addEventListener('load', changePhoneImageOnScroll);
  }


  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Opens external links in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();






